import API from 'services/api';

export const getContracts = (propertyCode: string) => {
  return API.get(`/api/accommodation/properties/${propertyCode}/contracts-by-code`).then(
    res => res?.data,
  );
};
